const QUANTITY_PER_UNIT = 1000;

export { QUANTITY_PER_UNIT };
